import { render, staticRenderFns } from "./OnboardingRegister.handler.vue?vue&type=template&id=0d513474&"
import script from "./OnboardingRegister.handler.vue?vue&type=script&lang=ts&"
export * from "./OnboardingRegister.handler.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports